module.exports = __webpack_public_path__ + "static/media/search.b85a6ed3.svg";